<template>
  <section class="container list-style05-wrap mt-10" id="body">
    <h2 class="subtit">Body</h2>
    <ul class="row list-style05">
      <li class="col-6 col-sm-4" v-for="item in products" :key="item.productsId">
        <a href="" @click.prevent="$emit('move-to-detail-page',item.productsId)">
          <div class="list-style05--img mb-2">
            <img :src="item.productsMainImageUrl" alt="">
          </div>
          <h3 class="list-style05--tit white-space--pre">{{item.productsPageKoreanName}}</h3>
          <div class="list-style05--desc white-space--pre">{{item.productsPageEnglishName}}</div>
        </a>
      </li>
    </ul>
  </section>
</template>

<script>
export default {
  name: 'Body',
  props: {
    products: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
